import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const estadisticas = `${baseUrl}/estadisticas`;

export const getDashboardService = async (tipo, params) => {
  const res = await axios.get(`${estadisticas}/${tipo}`, {
    headers: token({}),
    params,
  });
  return res;
};
